<template>
  <ModalDefault modal_id="showTicketModal"
                size="modal-lg w-100"
                header="y"
                :modal_header="titleModalMobile"
                icon=""
                class_header=""
                :style_top_header="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; top: 0; min-width: 100%; z-index: 999;' : ''"
                :style_footer="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; bottom: 0; min-width: 100%; z-index: 999;' : ''"
                class_footer="border-top"
                :lead_id="tickets.ticket.lead_id"
                class_body="p-0 "
                footer="y">
    <div slot="body" :style="($mq === 'mobile' || $mq === 'tablet') ? 'padding-top: 110px;' : ''">
      <!-- Vide componente ModalDefault-->
      <div
          :style="($mq === 'mobile' || $mq === 'tablet') ? 'min-height: 85vh;' : 'min-height: 500px; max-height: 500px;'"
          style="overflow-y: auto;"
          class="card-body">
        <!--Chat-->
        <div v-if="tickets.ticket_view === 1" id="chat_conversation2"
             class="chat_conversation px-2"
             :class="($mq === 'mobile' || $mq === 'tablet') ? 'mb-4 pb-5' : 'pb-1'">
          <!-- ORDENA POR ID -->
          <ChatBalloonDefault class="animated--grow-in" :history="history" v-for="history in orderedHistories"
                              :key="history.id"/>
        </div>
        <!--Contato-->
        <div v-if="tickets.ticket_view === 2">
          <!--Nome / Contato-->
          <div class="row justify-content-between px-3">
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <i class="bx bx-user bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_42') }}</small>
                  <div class="pb-0 ellipsis">
                      <span
                          :title="getLeadObject('id', tickets.ticket.lead_id).name ? getLeadObject('id', tickets.ticket.lead_id).name : '---'"
                          class="ellipsis title-color">
                        {{
                          getLeadObject('id', tickets.ticket.lead_id).name ? getLeadObject('id', tickets.ticket.lead_id).name : '---'
                        }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <i class="bx bx-phone bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_54') }}</small>
                  <div class="pb-0 ellipsis">
                      <span
                          :title="getLeadObject('id', tickets.ticket.lead_id).phone_hidden ? getLeadObject('id', tickets.ticket.lead_id).phone_hidden : '---'"
                          class="ellipsis title-color">
                        {{
                          getLeadObject('id', tickets.ticket.lead_id).phone_hidden ? getLeadObject('id', tickets.ticket.lead_id).phone_hidden : '---'
                        }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Email / Canal-->
          <div class="row justify-content-between pt-2 px-3">
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <i class="bx bx-envelope bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_161') }}</small>
                  <div class="pb-0 ellipsis">
                      <span
                          :title="getLeadObject('id', tickets.ticket.lead_id).email ? getLeadObject('id', tickets.ticket.lead_id).email : '---'"
                          class="ellipsis title-color">
                        {{
                          getLeadObject('id', tickets.ticket.lead_id).email ? getLeadObject('id', tickets.ticket.lead_id).email : '---'
                        }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <i class="bx bxl-whatsapp bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_4') }}</small>
                  <div class="pb-0 ellipsis">
                      <span
                          :title="getChannelObject('id', tickets.ticket.channel_id).name ? getChannelObject('id', tickets.ticket.channel_id).name : '---'"
                          class="ellipsis title-color">
                        {{
                          getChannelObject('id', tickets.ticket.channel_id).name ? getChannelObject('id', tickets.ticket.channel_id).name : '---'
                        }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Data de inscrição / Pesquisa de Satisfação-->
          <div class="row justify-content-between pt-2 px-3">
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <i class="bx bx-calendar bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_159') }}</small>
                  <div class="pb-0 ellipsis">
                    <span :title="tickets.ticket.created" class="ellipsis title-color"> {{
                        tickets.ticket.created
                      }} </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <i class="bx bx-star bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_826') }}</small>
                  <div class="pb-0 ellipsis">
                    <span :title="tickets.ticket.rate > 0 ? tickets.ticket.rate : ' ---'" class="ellipsis title-color"> {{
                        tickets.ticket.rate > 0 ? tickets.ticket.rate : ' ---'
                      }} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Qualificação / Interesse-->
          <div class="row justify-content-between pt-2 px-3">
            <!-- <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <i class="bx bx-bookmark-plus bx-sm pr-4"></i>
                  <div class="cursor_default text-left ellipsis">
                    <small>{{ getTranslations('expression_56') }}</small>
                    <div class="pb-0 ellipsis">
                    <span
                        :title="getMotiveObject('id', tickets.ticket.motive_id).name ? getMotiveObject('id', tickets.ticket.motive_id).name : '---'"
                        class="ellipsis title-color">
                      {{
                        getMotiveObject('id', tickets.ticket.motive_id).name ? getMotiveObject('id', tickets.ticket.motive_id).name : '---'
                      }}
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-md-6">
              <div class="d-flex align-items-center">
                <i class="bx bx-badge-check bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_31') }}</small>
                  <div class="pb-0 ellipsis">
                  <span
                      :title="getInterestObject('id', tickets.ticket.interest_id).id ? getInterestObject('id', tickets.ticket.interest_id).name : '---'"
                      class="ellipsis title-color"> {{
                      getInterestObject('id', tickets.ticket.interest_id).id ? getInterestObject('id', tickets.ticket.interest_id).name : '---'
                    }} </span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <!--Tags-->
          <div :class="($mq === 'mobile' || $mq === 'tablet') ? 'pb-5 mb-3' : ''"
               class="row justify-content-between pt-2 px-3">
            <div class="col-12">
              <div class="d-flex align-items-center">
                <i class="bx bx-purchase-tag bx-sm pr-4"></i>
                <div class="cursor_default text-left ellipsis">
                  <small>{{ getTranslations('expression_150') }}</small>
                  <div class="pb-2 ellipsis">
                    <VueSlickCarousel v-if="getLeadTagsArray('lead_id', tickets.ticket.lead_id).length > 0"
                                      style="cursor: all-scroll !important;" :arrows="false" :dots="false">
                      <div style="cursor: all-scroll !important;"
                           v-for="tag in getLeadTagsArray('lead_id', tickets.ticket.lead_id)" :key="tag.id"
                           class="pt-1">
                          <span style="cursor: all-scroll !important;" class="mr-1">
                            <div style="cursor: all-scroll !important;" class="chip mr-1 mt-1">
                              <div style="cursor: all-scroll !important;" class="chip-body">
                                <span class="chip-text cursor-default"
                                      style="font-size: 0.7rem; cursor: all-scroll!important;">{{
                                    getTagObject('id', tag.tag_id).name
                                  }}</span>
                              </div>
                            </div>
                          </span>
                      </div>
                    </VueSlickCarousel>
                    <span class="d-block pt-1" v-else>
                        ---
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Timeline-->
        <div v-if="tickets.ticket_view === 3" class="px-2 py-2">
          <TicketStatuses :data="tickets.ticket_statuses"/>
        </div>
      </div>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-between cursor_default text-left py-2 ellipsis pl-4 pr-3">
      <div>
        <span v-b-tooltip.top
              :title="tickets.ticket.status ? tickets.ticket.status.status : '---'"
              :class="tickets.ticket.status ? `bg-${tickets.ticket.status.label}` : 'bg-secondary'"
              class="text-white py-2 px-3">
          <span>{{ tickets.ticket.status ? tickets.ticket.status.status : '---' }}</span>
        </span>
      </div>

      <div class="d-flex">
        <div v-if="tickets.ticket.status && tickets.ticket.status.done === 0 && [1,2].includes(me.data.role_key)"
             @click.prevent="closeProtocolWindow">
          <span class="shadow-sm cursor_pointer btn-outline-danger py-2 px-3 mr-2">
            <i class="bx bx-block"></i>
            <span class="hidden-sm ml-2">{{ getTranslations('expression_541') }}</span>
          </span>
        </div>
        <div v-if="tickets.ticket.status && tickets.ticket.status.done === 0 && [1,2].includes(me.data.role_key)">
          <span data-toggle="modal"
                data-dismiss="modal"
                @click="clearTransfer"
                data-target="#transferTicketAdminModal"
                class="shadow-sm cursor_pointer btn-outline-primary rounded-0 py-2 px-3 mr-2">
            <i class="bx bx-transfer-alt"></i>
            <span class="hidden-sm ml-2">{{ getTranslations('expression_538') }}</span>
          </span>
        </div>
        <div>
          <span @click.prevent="openUrl(tickets.ticket.url_pdf)"
                class="shadow-sm cursor_pointer btn-secondary text-white py-2 px-3">
            <i class="bx bxs-file-pdf"></i>
            <span class="hidden-sm ml-2">{{ getTranslations('expression_799') }}</span>
          </span>
        </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import ChatBalloonDefault from "../../components/chat/ChatBalloonDefault";
import VueSlickCarousel from 'vue-slick-carousel'
import TicketStatuses from "../general/TicketStatuses";
import $ from "jquery";

export default {
  name: "ModalShowTicket",
  components: {
    TicketStatuses,
    ModalDefault,
    ChatBalloonDefault,
    VueSlickCarousel
  },
  computed: {
    ...mapState(['users', 'tickets', 'me', 'configs']),
    ...mapGetters([
      'getHistoriesArray',
      'getTagObject',
      'getLeadTagsArray',
      'getLeadObject',
      'getInterestObject',
      'getMotiveObject',
      'getChannelObject',
    ]),
    // Ordenar por ID
    orderedHistories() {
      // return _.orderBy(this.getHistoriesArray('ticket_id', this.tickets.ticket.id), ['id'], ['asc']);
      return _.orderBy(this.tickets.histories_followup_ticket, ['id'], ['asc']);
    },
    titleModalMobile() {
      if (this.$mq === 'mobile' || this.$mq === 'tablet') {
        return `${this.getLeadObject('id', this.tickets.ticket.lead_id).name ? this.getLeadObject('id', this.tickets.ticket.lead_id).name : '---'}`
      } else {
        return `${this.getLeadObject('id', this.tickets.ticket.lead_id).name ? this.getLeadObject('id', this.tickets.ticket.lead_id).name : '---'} - ${this.getLeadObject('id', this.tickets.ticket.lead_id).phone_hidden ? this.getLeadObject('id', this.tickets.ticket.lead_id).phone_hidden : '---'}`
      }
    }
  },
  mounted() {
    $('#showTicketModal').on('hidden.bs.modal', () => {
      this.tickets.ticket_view = 1
    })
  },
  methods: {
    downScrollChat() {
      this.tickets.ticket_view = 1; // set ticket
      setTimeout(() => {
        document.getElementById('chat_conversation').scrollIntoView({block: "end", behavior: "smooth"});
      }, 500);
    },
    openUrl(payload) {
      window.open(payload, "_blank");
    },
    clearTransfer() {
      this.tickets.ticket_transfer = {
        operator_id: null,
        department_id: null,
        channel_id: null
      }
    },
    closeProtocolWindow() {
      this.$swal.fire({
        title: this.getTranslations('expression_895'),
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.getTranslations('expression_896'),
        cancelButtonText: this.getTranslations('expression_355')
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('closeTicket', this.tickets.ticket)
        }
      })
    },
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>
<style scoped>
</style>
